/**
 * defa.views.RoleApplicationCollectionView
 * A collectionview for RoleApplication snippets.
 * @version 1.0.0
 */
import EmptyView      from 'scripts/defa/basic/view-empty-view';
import RoleApplicationSnippet from 'scripts/defa/role-applications/view-role-application-snippet';
import CollectionView   from '../../poppet/collection-view';

export const RoleApplicationCollectionView = CollectionView.extend( {
	childView: RoleApplicationSnippet,
	emptyView: EmptyView,
	
	emptyViewOptions: {
		context: 'no:applications',
	},
} );
export default RoleApplicationCollectionView;